module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('img', {
    staticClass: "top-logo",
    attrs: {
      "src": require("../assets/dontomas-logo.gif"),
      "alt": "Don Tomas"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d39d8afa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d39d8afa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = 158
// module chunks = 1